<template>
  <div class="row" style="row-gap:18px;">
    <div class="col-6 col-md-3" v-for="card in cards" :key="card.key">
      <div class="text-secondary mb-1" style="font-size:12px;">{{ card.label }}</div>

      <span v-if="loading" class="placeholder-glow d-block">
        <span class="placeholder col-8 rounded"></span>
      </span>
      <template v-else-if="card.restricted && !canViewRevenue">
        <div style="font-size:18px;font-weight:700;color:#0f172a;">
          <i class="bi bi-lock-fill" style="font-size:.9rem;"></i>
        </div>
      </template>
      <div v-else class="kpi-value">
        {{ card.format ? card.format(kpis[card.key]) : kpis[card.key] }}
      </div>

      <small v-if="card.sub && !loading" class="text-secondary">{{ card.sub }}</small>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AdminKpiCards',
  props: {
    kpis: { type: Object, default: () => ({}) },
    loading: { type: Boolean, default: false },
    canViewRevenue: { type: Boolean, default: false },
  },
  computed: {
    cards() {
      return [
        {
          key: 'mrr',
          label: 'MRR',
          format: v => 'KES ' + Number(v || 0).toLocaleString(),
          sub: 'Monthly recurring',
          restricted: true,
        },
        {
          key: 'collected_this_month',
          label: 'Collected (MTD)',
          format: v => 'KES ' + Number(v || 0).toLocaleString(),
          sub: 'Subscription fees, M-Pesa',
          restricted: true,
        },
        {
          key: 'active_companies',
          label: 'Active',
          sub: 'Subscribed companies',
        },
        {
          key: 'trial_companies',
          label: 'On Trial',
          sub: '≤ 30 days old',
        },
        {
          key: 'overdue_companies',
          label: 'Overdue',
          sub: 'Billing past due',
          restricted: true,
        },
        {
          key: 'orders_today',
          label: 'Orders Today',
          sub: 'All companies',
        },
        {
          key: 'aov_today',
          label: 'AOV Today',
          format: v => 'KES ' + Number(v || 0).toLocaleString(undefined, { maximumFractionDigits: 0 }),
          sub: 'Avg order value',
          restricted: true,
        },
        {
          key: 'new_signups_7d',
          label: 'New (7d)',
          sub: 'Sign-ups this week',
        },
      ];
    },
  },
};
</script>

<style scoped>
.kpi-value {
  font-size: 20px;
  font-weight: 700;
  letter-spacing: -0.2px;
  line-height: 1.2;
  color: #0f172a;
}
</style>
